import React from 'react';
import AppHeader from './AppHeader';
import { useShowcaseMode } from '../hooks/useShowcaseMode';
import { useLocation } from 'react-router-dom';

/**
 * Default app chrome is hidden for showcase mode and the partner proposal,
 * which supplies its own public navigation.
 */
const ConditionalAppHeader: React.FC = () => {
  const isShowcaseMode = useShowcaseMode();
  const { pathname } = useLocation();
  if (
    isShowcaseMode ||
    /^\/partners\/(?:flat-six-coffee|thrive|peaked|down-to-earth)\/?$/.test(pathname) ||
    /^\/for(?:\/(?:builders|organizers|shops|clubs))?\/?$/.test(pathname)
  )
    return null;
  return <AppHeader />;
};

export default ConditionalAppHeader;
